import { apiClient } from 'api/apiClient';
import { firebaseConfig } from 'configs/firebaseConfig';
import { initializeApp } from 'firebase/app';
import { Messaging, deleteToken, getMessaging, getToken } from 'firebase/messaging';

class MessagingService {
  SERVICE_PATH = '/ns';
  messaging: Messaging | null = null;
  alreadyRegistered = false;
  serviceWorker: ServiceWorker | null = null;
  registration: ServiceWorkerRegistration | null = null;

  removeToken = () => {
    this.messaging && deleteToken(this.messaging);
  };

  register = async (token: string) => {
    const getPath = (path = '', isPublic = false) =>
      `${apiClient.getPath(this.SERVICE_PATH, isPublic)}${apiClient.Paths.FCM}${path}`;

    await apiClient.apiInstance.post<{ token: string }>(getPath('/register'), {
      token,
    });
  };

  subscribe = async () => {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted' || !this.messaging || !this.registration) return;

    // can produce error/warning on the first run, it's ok
    const token = await getToken(this.messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: this.registration,
    });

    if (token) {
      await this.register(token);
    }
  };

  initFB = async () => {
    const app = initializeApp(firebaseConfig);
    this.messaging = getMessaging(app);

    try {
      await this.subscribe();
    } catch (error: any) {
      console.log(error);
    }
  };

  registerMessageListener = async () => {
    if (this.alreadyRegistered || !('serviceWorker' in navigator)) return;
    this.alreadyRegistered = true;
    this.registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    if (this.registration.installing) {
      this.serviceWorker = this.registration.installing;
    } else if (this.registration.waiting) {
      this.serviceWorker = this.registration.waiting;
    } else if (this.registration.active) {
      this.serviceWorker = this.registration.active;
    }

    if (!this.serviceWorker) return;

    if (this.serviceWorker.state == 'activated') {
      this.initFB();
      return;
    }

    this.serviceWorker.addEventListener('statechange', (e: any) => {
      if (e.target?.state == 'activated') {
        this.initFB();
      }
    });
  };
}

export const messagingService = new MessagingService();
